import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { ensureSession, isSsoSession, readSession, SESSION_CHANGED, SESSION_RENEWED,
    SESSION_REQUIRED, signInAgain } from 'helpers/api/session';

const SessionRenewal = () => {
    const [required, setRequired] = useState(false);
    const [busy, setBusy] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    useEffect(() => {
        let lastActivity = Date.now();
        const active = () => { lastActivity = Date.now(); };
        const check = () => {
            if (!document.hidden && readSession() && Date.now() - lastActivity < 5 * 60000) {
                void ensureSession().catch(() => { /* API errors remain visible; interaction uses the sign-in dialog. */ });
            }
        };
        const focus = () => { active(); check(); };
        const show = () => { if (readSession()) setRequired(true); };
        const renewed = () => { setRequired(false); setPassword(''); setError(''); };
        const changed = () => { if (!readSession()) renewed(); };
        window.addEventListener(SESSION_REQUIRED, show);
        window.addEventListener(SESSION_RENEWED, renewed);
        window.addEventListener(SESSION_CHANGED, changed);
        window.addEventListener('pointerdown', active);
        window.addEventListener('keydown', active);
        window.addEventListener('focus', focus);
        document.addEventListener('visibilitychange', focus);
        const timer = window.setInterval(check, 30000);
        return () => {
            window.clearInterval(timer);
            window.removeEventListener(SESSION_REQUIRED, show);
            window.removeEventListener(SESSION_RENEWED, renewed);
            window.removeEventListener(SESSION_CHANGED, changed);
            window.removeEventListener('pointerdown', active);
            window.removeEventListener('keydown', active);
            window.removeEventListener('focus', focus);
            document.removeEventListener('visibilitychange', focus);
        };
    }, []);
    const session = readSession();
    const sso = isSsoSession(session);
    return <Modal show={required} backdrop="static" keyboard={false} centered>
        <Modal.Header><Modal.Title>Sign in to continue editing</Modal.Title></Modal.Header>
        <Form onSubmit={async event => {
            event.preventDefault();
            if (busy) return;
            setBusy(true); setError('');
            try { await signInAgain(password); }
            catch (failure: any) { setError(failure.response?.data?.message || failure.message || 'Sign-in failed. Please try again.'); }
            finally { setBusy(false); }
        }}>
            <Modal.Body>
                <p>Your sign-in has expired. Your edits are still on this page. Sign in again, then retry saving.</p>
                {error && <Alert variant="danger" role="alert">{error}</Alert>}
                {!sso && <>
                    <Form.Group className="mb-3" controlId="session-email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" autoComplete="username" readOnly value={session?.user?.email || session?.email || ''} />
                    </Form.Group>
                    <Form.Group controlId="session-password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" autoComplete="current-password" value={password}
                            required disabled={busy} onChange={event => setPassword(event.target.value)} />
                    </Form.Group>
                </>}
            </Modal.Body>
            <Modal.Footer><Button type="submit" disabled={busy}>
                {busy ? 'Signing in…' : sso ? 'Sign in with Microsoft' : 'Sign in again'}
            </Button></Modal.Footer>
        </Form>
    </Modal>;
};
export default SessionRenewal;
